import { Menu, User } from "lucide-react";
import { useAuthStore } from "@/pages/auth/auth.store";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  title?: string;
  onMenuClick?: () => void;
}

export default function Header({ title, onMenuClick }: HeaderProps) {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate("/profile");
  };

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-[#0F1524] border-b border-[#1A2235] sticky top-0 z-10">
      <div className="flex items-center gap-3">
        {onMenuClick && (
          <button
            onClick={onMenuClick}
            className="p-2 rounded-lg bg-[#1A2235] hover:bg-[#253045] transition-colors md:hidden"
          >
            <Menu size={24} className="text-[#00C2CB]" />
          </button>
        )}
        {title && (
          <h2 className="text-xl font-medium text-[#00C2CB] hidden md:block">
            {title}
          </h2>
        )}
      </div>

      {/* User profile section */}
      <div className="flex items-center gap-3">
        <span className="text-white font-medium">{user?.name || "User"}</span>
        <button
          onClick={handleProfileClick}
          className="w-9 h-9 rounded-full overflow-hidden bg-[#1A2234] flex items-center justify-center"
          style={{
            filter: "drop-shadow(0px 0.77px 5.07px rgba(0,0,0,0.25))",
          }}
        >
          <User size={18} className="text-white" />
        </button>
      </div>
    </header>
  );
}
